<template>
  <div class="layout">
    <!-- Encabezado -->
<header class="header">
  <!-- IZQUIERDA: Botón y Título -->
  <div class="left">
    <button class="menu-toggle" @click="toggleDrawer" v-if="isMobile">☰</button>
  </div>

  <!-- DERECHA: Campanita -->
  <div class="right">
    <ThemeToggle isNavbar />
    <NotificacionesIcon v-if="user" />
  </div>
</header>



    <div class="body-content">
      <!-- Sidebar importado -->
      <SidebarPrincipal
        :drawer="drawer"
        :isMobile="isMobile"
        :user="user"
        :totalPendientes="totalPendientes"
        @logout="logoutUser"
        @toggle-drawer="toggleDrawer"
      />

      <!-- Contenido principal -->
      <div class="main-content" :class="{ 'no-scroll': drawer && isMobile }">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import { API_URL } from '@/config/config';
import SidebarPrincipal from '@/layouts/SidebarPrincipal.vue';
import NotificacionesIcon from '@/components/hotel/notificacionesreservas.vue';
import ThemeToggle from '@/components/ThemeToggle.vue';

export default {
  name: 'MainLayout',
  components: {
    SidebarPrincipal,
    NotificacionesIcon,
    ThemeToggle
  },
  data() {
    return {
      drawer: false,
      isMobile: false,
    };
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters(['totalPendientes'])
  },
  mounted() {
    this.checkScreen();
    window.addEventListener('resize', this.checkScreen);
    this.fetchTotalPendientes();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreen);
  },
  methods: {
    ...mapActions(['logout', 'fetchTotalPendientes']),

    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    checkScreen() {
      this.isMobile = window.innerWidth <= 768;
      if (!this.isMobile) this.drawer = false;
    },
    async logoutUser() {
      try {
        await axios.post(`${API_URL}/logout`, {}, { withCredentials: true });
        this.logout();
        this.$router.push('/login');
      } catch (error) {
        console.error('Error al cerrar sesión:', error);
      }
    }
  }
};
</script>



<style scoped>
/* Solo estilos que afectan al layout general y contenido */
.layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  margin: 0;
}

.header {
  background-color: #2c3e50;
  color: white;
  display: flex;
  align-items: center;
  padding: 5px 20px;
  justify-content: space-between;
}

:global(.dark) .header {
  background-color: #1e293b;
}

.menu-toggle {
  font-size: 24px;
  margin-right: 15px;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
}

.logo {
  margin: 0;
  font-size: 20px;
}

.body-content {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.main-content {
  flex: 1;
  overflow-y: auto;
  background-color: #f8fafc;
}

:global(.dark) .main-content {
  background-color: #0f172a;
}

.no-scroll {
  overflow: hidden;
}
.left {
  display: flex;
  align-items: center;
}

.right {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
